var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"image",attrs:{"srcset":_vm.srcset,"sizes":_vm.sizes,"src":_vm.src,"width":_vm.imageWidth,"alt":_vm.alt},on:{"load":_vm.updateSizes}})
}
var staticRenderFns = []

export { render, staticRenderFns }